<template>
    <div class="inner">
        <div class="xh-left">
            <div class="xh-left-top">
                <div class="xh-left-top-column-1">
                    <div class="chart-con">
                        <div class="chart-title">
                            <IconTitle :title="'全国学会建设情况'" :titleType="1" :link="'/xhqj/jsqk'"
                                       :iconName="'yemiankuangjia'"/>
                        </div>
                        <div class="chart-con-main">
                            <div class="chart" id="chart1"></div>
                            <div class="axis-title">
                                常务理事会人数
                            </div>
                        </div>
                    </div>
                </div>
                <div class="xh-left-top-column-2">
                    <div class="chart-con">
                        <div class="chart-title">
                            <IconTitle :title="'全国学会理事会成员情况'" :titleType="1" :link="'/xhqj/lshcy'"
                                       :iconName="'yemiankuangjia'"/>
                        </div>
                        <div class="chart-con-main">
                            <div class="chart" id="chart2"></div>
                        </div>
                    </div>
                    <div class="chart-con">
                        <div class="chart-title">
                            <IconTitle :title="'全国学会会员情况'" :titleType="1" :link="'/xhqj/hyqk'"
                                       :iconName="'yemiankuangjia'"/>
                        </div>
                        <div class="chart-con-main">
                            <div class="chart" id="chart3"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="xh-left-btm">
                <div class="chart-con">
                    <div class="chart-title">
                        <IconTitle :title="'全国学会办事机构党组织类型'" :iconName="'jingfeiyongtu'"/>
                    </div>
                    <div class="chart-con-main">
                        <div class="chart" id="chart4"></div>
                    </div>
                </div>
                <div class="chart-con">
                    <div class="chart-title">
                        <IconTitle :title="'全国学会举办学术会议次数'" :iconName="'cangku_kucunxiangqing'"/>
                    </div>
                    <div class="chart-con-main pie-chart">
                        <div class="chart" id="chart5"></div>
                    </div>
                </div>
                <div class="chart-con">
                    <div class="chart-title">
                        <IconTitle :title="'全国学会咨询工作情况'" :iconName="'cangku_cangneishicao'"/>
                    </div>
                    <div class="chart-con-main">
                        <div class="chart" id="chart6"></div>
                    </div>
                </div>
                <div class="chart-con fr">
                    <div class="chart-title">
                        <IconTitle :title="'全国学会举办科普宣讲活动'" :iconName="'duanxin1'"/>
                    </div>
                    <div class="chart-con-main pie-chart-2">
                        <div class="chart" id="chart7"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="xh-right">
            <div class="chart-con">
                <div class="chart-title">
                    <IconTitle :title="'全国学会综合业务能力评估'" :titleType="1" :link="'/xhqj/zhnl'"
                               :iconName="'yemiankuangjia'"/>
                </div>
                <div class="chart-con-main padding">
                    <div class="table-con">
                        <div class="thead">
                            <dl>
                                <dd class="center">
                                    排名
                                </dd>
                                <dd>学会名称</dd>
                                <dd class="center">
                                    分数
                                </dd>
                            </dl>
                        </div>
                        <div class="tbody" ref="estimateList">
                            <div>
                                <dl v-for="(item,index) of scoreData" :key="index">
                                    <dd class="center">
                                        {{ item.nos }}
                                    </dd>
                                    <dd>{{ item.name }}</dd>
                                    <dd class="center">
                                        {{ item.score }}
                                    </dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="chart-con">
                <div class="chart-title">
                    <IconTitle :title="'世界主要科技社团成立数量'" :titleType="1" :link="'/xhqj/sjkjst'"
                               :iconName="'yemiankuangjia'"/>
                </div>
                <div class="chart-con-main padding">
                    <div class="chart" id="chart8"></div>
                </div>
            </div>
            <div class="chart-con padding">
                <div class="chart-title">
                    <IconTitle :title="'智慧学会样板间'" :iconName="'daoru'"/>
                </div>
                <div class="chart-con-main">
                    <div class="acad-list srcoll-list" ref="ybjList">
                        <ul>
                            <li class="acad-item">
                                <router-link to="/ybj/hxh">
                                    <div class="acad-item-logo">
                                        <img src="@/assets/images/ybj/hxh.png" alt="">
                                    </div>
                                    <div class="acad-item-name">
                                        <div class="acad-item-name-main">
                                            <span>管理数字化-中国化学会</span>
                                        </div>
                                    </div>
                                </router-link>
                            </li>
                            <li class="acad-item">
                                <router-link to="/ybj/jxgc">
                                    <div class="acad-item-logo">
                                        <img src="@/assets/images/ybj/jxxh.png" alt="">
                                    </div>
                                    <div class="acad-item-name">
                                        <div class="acad-item-name-main">
                                            <span>知识产品化-中国机械工程学会</span>
                                        </div>
                                    </div>
                                </router-link>
                            </li>
                            <li class="acad-item">
                                <router-link to="/ybj/qcxh">
                                    <div class="acad-item-logo">
                                        <img src="@/assets/images/ybj/qcxh.png" alt="">
                                    </div>
                                    <div class="acad-item-name">
                                        <div class="acad-item-name-main">
                                            <span>服务平台化-中国汽车工程学会</span>
                                        </div>
                                    </div>
                                </router-link>
                            </li>
                            <li class="acad-item">
                                <router-link to="/ybj/djgc">
                                    <div class="acad-item-logo">
                                        <img src="@/assets/images/ybj/djxh.png" alt="">
                                    </div>
                                    <div class="acad-item-name">
                                        <div class="acad-item-name-main">
                                            <span>应用模块化-中国电机工程学会</span>
                                        </div>
                                    </div>
                                </router-link>
                            </li>
                            <li class="acad-item">
                                <router-link to="/ybj/glxh">
                                    <div class="acad-item-logo">
                                        <img src="@/assets/images/ybj/glxh.png" alt="">
                                    </div>
                                    <div class="acad-item-name">
                                        <div class="acad-item-name-main">
                                            <span>交流国际化-中国公路学会</span>
                                        </div>
                                    </div>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import IconTitle from '@/components/icontitle';
    import {
        xhjianshe,
        xhlishi,
        vipNum,
        organizationType,
        meetingCount,
        consulting,
        kpxj,
        assess,
        createCount
    } from "@/assets/scripts/api/xhqj";
    const CHARTS_COLORS = ["#FC058F", '#344ED5', '#30CF70', '#05C1FC', '#0179FF', '#344ED5', '#01CDFF'];
    const barColor = ['#3748b2', '#3849b5', '#079ed4', '#d12585', '#29a963', '#c27a19'];
    const PIE_COLORS = ["#FB058F", "#3748b2",'#30CF70', "#0078FF", '#01CDFF'];
    const XAXIS_LINE_COLOR = '#3047C2';
    const TEXT_COLOR = '#B6C8FF';
    const axisStyle = {
        splitLine: {
            lineStyle: {
                type: 'dotted',
                color: XAXIS_LINE_COLOR
            }
        },
        axisLabel: {
            color: TEXT_COLOR
        },
        nameTextStyle: {
            color: TEXT_COLOR,
            fontSize: 12
        }
    };
    export default {
        name: 'XueHuiQuanJing',
        components: {
            IconTitle
        },
        data() {
            return {
                acadData: [],
                scoreData: []
            }
        },
        mounted() {
            this.init();

            this.$nextTick(() => {
                this.$scrollTable(this.$refs.ybjList);
            });
        },
        methods: {
            init() {
                //this.initChart1();
                this.xhjianshe();
                this.xhlishi();
                this.vipNum();
                this.organizationType();
                this.meetingCount();
                this.consulting();
                this.kpxj();
                this.assess();
                this.createCount();
            },
            assess() {
                assess().then(({data}) => {
                    this.scoreData = data;

                    this.$nextTick(() => {
                        this.$scrollTable(this.$refs.estimateList);
                    });
                })
            },
            createCount() {
                createCount().then((response) => {
                    let data = response.data;

                    this.initChart8(data);
                })
            },
            xhjianshe() {
                xhjianshe().then((response) => {
                    let data = response.data;

                    this.initChart1(data);
                })
            },
            xhlishi() {
                xhlishi().then(response => {
                    let data = response.data,
                        obj = {
                            list: [],
                            column: []
                        };

                    data.forEach(item => {
                        obj.list.push(item.num);
                        obj.column.push(item.name);
                    })

                    this.initChart2(obj);
                })
            },
            vipNum() {
                vipNum().then((response) => {
                    let data = response.data;

                    this.initChart3(data);
                })
            },
            organizationType() {
                organizationType().then((response) => {
                    let data = response.data,
                        nameArr = [],
                        seriesData = [];

                    data.forEach(item => {
                        nameArr.push(item.name);
                        seriesData.push(item.num)
                    })
                    this.initChart4(nameArr, seriesData);
                })
            },
            meetingCount() {
                meetingCount().then((response) => {
                    let data = response.data,
                        nameArr = [],
                        seriesData = [],
                        total = 0;

                    data.forEach(item => {
                        nameArr.push(item.name);
                        seriesData.push(item.num)
                    })
                    seriesData.forEach(item => {
                        total += Number(item)
                    })
                    this.initChart5(nameArr, seriesData, total);
                })
            },
            consulting() {
                consulting().then((response) => {
                    let data = response.data;
                    consulting(3).then((response) => {
                        let datas = response.data;

                        this.initChart6(data,datas);
                    })

                })
            },
            kpxj() {
                kpxj().then((response) => {
                    let data = response.data,
                        nameArr = [],
                        seriesData = [];

                    data.forEach(item => {
                        nameArr.push(item.name);
                        seriesData.push(item.num)
                    })

                    this.initChart7(nameArr, seriesData);
                })
            },
            initChart1(data) {
                const chart = echarts.init(document.getElementById("chart1"));
                const maxData = data.map((item) => {
                    return item[0];
                })
                const option = {
                    color: barColor,
                    yAxis: Object.assign({axisLine: {show: false}, name: "理事会人数"}, axisStyle),
                    xAxis: Object.assign({
                        axisLine: {
                            lineStyle: {
                                color: XAXIS_LINE_COLOR
                            }
                        }
                    }, axisStyle),
                    grid: {
                        left: 50,
                        right: '5%',
                        bottom: '40',
                        containLabel: true
                    },
                    visualMap: [{
                        show: false,
                        min: 0,
                        max: Math.max.apply(null, maxData),
                        dimension: 5,
                        inRange: {
                            color: barColor,
                        }
                    },],
                    tooltip: {
                        type: 'item',
                        formatter: function (params) {
                            const data = params.data;
                            let str = [];

                            str.push(data[3]);
                            str.push(`<span>常务理事会人数: ${data[0]}</span>`);
                            str.push(`<span>理事会人数: ${data[1]}</span>`);
                            str.push(`<span>学会负责人规模: ${data[2]}</span>`);

                            return str.join('</br>');
                        },
                    },
                    series: [
                        {
                            symbolSize: function (data) {
                                return data[2] * 2;
                            },
                            label: {
                                show: false
                            },
                            itemStyle: {
                                opacity: 1
                            },
                            data: data,
                            type: 'scatter'
                        }
                    ]
                };

                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);

            },
            initChart2(data) {
                const chart = echarts.init(document.getElementById("chart2"));
                const option = {
                    grid: {
                        left: 0,
                        right: 0,
                        bottom: 30,
                        top: 30
                    },
                    tooltip: {
                        trigger: 'axis',
                    },
                    yAxis: Object.assign({
                        axisLine: {show: false},
                        type: "value"
                    }, axisStyle),
                    xAxis: Object.assign({
                        axisLine: {
                            lineStyle: {color: XAXIS_LINE_COLOR},
                            onZero: false
                        },
                        data: data.column,
                        type: 'category'
                    }, axisStyle),
                    series: [{
                        data: data.list,
                        type: 'bar',
                        barWidth: '30%',
                        itemStyle: {
                            color: CHARTS_COLORS[4]
                        }
                    }]
                };

                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart3(data) {
                const chart = echarts.init(document.getElementById("chart3"));
                const option = {
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: data.title,
                        textStyle: {
                            color: TEXT_COLOR
                        },
                        icon: "circle",
                        itemWidth: 6,
                        bottom: 0
                    },
                    grid: {
                        left: 0,
                        right: 0,
                        top: 20,
                        bottom: 50
                    },
                    xAxis: Object.assign({
                        axisLine: {
                            lineStyle: {color: XAXIS_LINE_COLOR},
                            onZero: false
                        },
                        boundaryGap: false,
                        data: data.column,
                        type: 'category'
                    }, axisStyle),
                    yAxis: Object.assign({
                        axisLine: {show: false},
                        splitLine: {show: false},
                        type: "value"
                    }, axisStyle),
                    series: [{
                        name: data.title[0],
                        type: 'line',
                        stack: '总量',
                        smooth: true,
                        itemStyle: {
                            color: CHARTS_COLORS[3],
                            borderWidth: 6
                        },
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0,
                                    color: 'rgba(5, 193, 252, 0.8)' // 0% 处的颜色
                                }, {
                                    offset: 1,
                                    color: 'rgba(5, 193, 252, 0)' // 100% 处的颜色
                                }],
                            }
                        },
                        symbol: 'circle',
                        data: data.list[0]
                    }]
                };

                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart4(nameArr, seriesData) {
                const chart = echarts.init(document.getElementById("chart4"));
                const option = {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    grid: {
                        left: 0,
                        right: 14,
                        bottom: 30,
                        top: 30,
                        containLabel: true
                    },
                    xAxis: Object.assign({
                        axisLine: {show: false},
                        splitLine: {show: false},
                        type: "value",
                    }, axisStyle),
                    yAxis: Object.assign({
                        axisLine: {
                            lineStyle: {color: '#3047C2'},
                            onZero: false
                        },
                        data: nameArr,
                        type: 'category'
                    }, axisStyle),
                    series: [{
                        name: '2020年',
                        type: 'bar',
                        data: seriesData,
                        barWidth: '30%',
                        itemStyle: {
                            color: CHARTS_COLORS[6]
                        }
                    }]
                };

                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart5(nameArr, seriesData, total) {
                const chart = echarts.init(document.getElementById("chart5"));
                let pieData = {
                    column: nameArr,
                    list: seriesData
                }
                chart.setOption(this.getPieOption(pieData, 1, total), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart6(data,datas) {
                const chart = echarts.init(document.getElementById("chart6"));
                const option = {
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: ['举办咨询活动', '提供咨询报告'],
                        textStyle: {
                            color: TEXT_COLOR
                        },
                        icon: "circle",
                        itemWidth: 6,
                        bottom: 0
                    },
                    grid: {
                        left: 40,
                        right: 40,
                        top: 40,
                        bottom: 50
                    },
                    xAxis: Object.assign({
                        axisLine: {
                            lineStyle: {color: XAXIS_LINE_COLOR},
                            onZero: false
                        },
                        boundaryGap: true,
                        data: data.column,
                        type: 'category'
                    }, axisStyle),
                    yAxis: [Object.assign({
                        axisLine: {show: false},
                        name: "次",
                        position: 'left',
                        splitLine: {show: true},
                        type: "value",
                    }, axisStyle), Object.assign({
                        axisLine: {show: false},
                        name: "篇",
                        position: 'right',
                        splitLine: {show: true},
                        type: "value",
                    }, axisStyle)],
                    series: [{
                        name: '举办咨询活动',
                        type: 'line',
                        smooth: true,
                        itemStyle: {
                            color: CHARTS_COLORS[3],
                            borderWidth: 6
                        },
                        symbol: 'circle',
                        data: data.list
                    }, {
                        name: '提供咨询报告',
                        type: 'line',
                        smooth: true,
                        yAxisIndex: 1,
                        itemStyle: {
                            color: CHARTS_COLORS[0],
                            borderWidth: 6
                        },
                        symbol: 'circle',
                        data: datas.list
                    }]
                };
                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart7(nameArr, seriesData) {
                const chart = echarts.init(document.getElementById("chart7"));
                let pieData = {
                    column: nameArr,
                    list: seriesData
                }

                chart.setOption(this.getPieOption(pieData, 0), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart8(data) {
                const chart = echarts.init(document.getElementById("chart8"));
                const option = {
                    grid: {
                        left: 35,
                        right: 5,
                        bottom: 40,
                        top: 20
                    },
                    tooltip: {
                        trigger: 'axis',
                    },
                    yAxis: Object.assign({}, axisStyle, {
                        axisLine: {show: false},
                        splitLine: {
                            show: false,
                            lineStyle: {}
                        },
                        type: "value",
                        name: "历年累计",
                        nameLocation: "start",
                    }),
                    xAxis: Object.assign({
                        axisLine: {
                            lineStyle: {color: XAXIS_LINE_COLOR},
                            onZero: false
                        },
                        data: data.column,
                        type: 'category',
                    }, axisStyle),
                    series: [{
                        data: data.list[0],
                        type: 'bar',
                        barWidth: '30%',
                        itemStyle: {
                            color: CHARTS_COLORS[4]
                        }
                    }]
                };

                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            getPieOption(data, type, total) {
                let seriesData = [],
                    option = {},
                    title = {};

                if (type) {
                    title = {
                        text: '{name|' + total + '}',
                        top: 'center',
                        left: 'center',
                        textStyle: {
                            rich: {
                                name: {
                                    fontSize: 18,
                                    fontWeight: 'bold',
                                    color: TEXT_COLOR,
                                    padding: [10, 0]
                                },
                                val: {
                                    fontSize: 16,
                                    fontWeight: 'normal',
                                    color: TEXT_COLOR,
                                }
                            }
                        }
                    }
                }

                data.list.forEach((item, index) => {
                    seriesData.push({
                        name: data.column[index],
                        value: item
                    });
                });

                option = {
                    color: PIE_COLORS,
                    title: title,
                    tooltip: {
                        trigger: 'item',
                        formatter: "{b} </br> {c} ({d}%)"
                    },
                    series: [{
                        type: 'pie',
                        center: ['50%', '50%'],
                        radius: type ? ['60%', '75%'] : [0, '75%'],
                        label: {
                            show: false
                        },
                        data: seriesData
                    }]
                };
                return option;
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "@/assets/scss/mixins/_variables";

    .inner {
        color: $primary-text-color;
        font-size: 0.19rem;
        padding: 2% 2.08% 0;

        .xh {

            &-left,
            &-right {
                height: 96.04%;
            }

            &-left {
                float: left;
                width: 74.4565%;

                /*1370px*/
                .xh-left-top {
                    overflow: hidden;
                    height: 64%;
                    margin-bottom: 2.3%;

                    &-column-1 {
                        float: left;
                        width: 65.69%;
                        height: 100%;

                        .chart-con {
                            height: 100%;
                        }
                    }

                    &-column-2 {
                        float: right;
                        width: 31.3868%;
                        height: 100%;

                        .chart-con {
                            height: 50%;
                        }
                    }
                }

                .xh-left-btm {
                    height: 33.3%;

                    .chart-con {
                        width: 23.3576%;
                        height: 100%;
                        float: left;
                        margin-right: 2.189%;

                        &:last-child {
                            margin-right: 0;
                        }
                    }
                }
            }

            &-right {
                float: right;
                width: 23.3695%;
                border: 1px solid rgba(35, 51, 136, 1);
                box-shadow: 0px 0px 150px 0px rgba(39, 58, 159, 0.5) inset;
                /*1370px*/

                .chart-con {
                    height: 33.33%;
                    &:first-child {
                        height: 32%;
                    }
                    &:nth-of-type(2) {
                        margin-bottom: 3%;
                    }

                    &.map-chart-con {
                        height: 66.66%;
                        background: no-repeat center/cover;
                    }
                }

                .padding {
                    padding: 0 6.97%;
                }
            }
        }

        .chart-con {
            // height: 33.33%;
            overflow: hidden;

            &.fr {
                float: right;
            }

            .chart-title {
                margin-bottom: 0.2rem;
            }

            .table-con {
                height: calc(100% - 0.2rem);
                overflow: hidden;

                dl {
                    width: 100%;
                    overflow: hidden;
                }

                dd {
                    padding: 8px 0;
                    font-size: 0.12rem;
                    color: #B5C8FF;
                    font-weight: 400;
                    width: 30%;
                    float: left;

                    &:nth-child(2) {
                        width: 50%;
                    }

                    &:last-child {
                        width: 20%;
                    }

                    &.center {
                        text-align: center;
                    }

                }

                .thead {
                    dl {
                        background-color: #131B4C;
                    }
                }

                .tbody {
                    height: calc(100% - 0.4rem);
                    overflow-y: hidden;
                    dl {

                        &:nth-of-type(even) {
                            dd {
                                background-color: #141D51;
                            }
                        }
                    }
                }

            }

            &.map-chart-con {
                height: 66.66%;
                background: no-repeat center/cover;
            }

            .chart-con-main {
                height: calc(100% - 0.8rem);
                position: relative;
                .axis-title{
                    position: absolute;
                    right:4.2%;
                    bottom:0.1rem;
                    font-size:0.14rem;
                }

                .chart {
                    height: 100%;

                }

                &.pie-chart {
                    .chart {
                        background: url('~@/assets/images/xhqj/piebg1.png') no-repeat center center / contain;
                    }
                }

                &.pie-chart-2 {
                    .chart {
                        // padding: 9.46% 6.1% 11.48%;
                        background: url('~@/assets/images/xhqj/piebg2.png') no-repeat center center / contain;
                    }
                }
            }
        }

        .srcoll-list {
            height: 100%;
            overflow: hidden;
        }

        .acad-list {
            .acad-item {
                width: 100%;
                border: 1px solid #141D51;
                background-color: change-color($table-border-color, $alpha: 0.5);
                padding: 0.11rem;
                height: 0.43rem;
                line-height: 0.43rem;
                box-sizing: content-box;
                overflow: hidden;
                margin-bottom: 0.11rem;
                margin-top: 0.1rem;

                &-logo,
                &-name {
                    float: left;
                }

                &-logo {
                    width: 0.43rem;
                    height: 100%;
                    overflow: hidden;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                &-name {
                    color: $primary-text-color;
                    margin-right: -0.43rem;
                    margin-left: 0.11rem;

                    &-main {
                        margin-right: 0.43rem;
                        font-size: 0.18rem;

                        span {
                            display: inline-block;
                            max-width: 100%;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;

                            &:hover {
                                color: change-color($primary-text-color, $alpha: 0.6);
                            }
                        }
                    }
                }
            }
        }
    }
</style>